import { defineStore } from 'pinia';
import router from '@/router'; // 导入路由实例
import { isMobileDevice } from '@/utils/index';
import { isMerchantPath, isMerchantRole, MERCHANT_LOGIN } from '@/utils/merchantAccess';
// 定义 user store
export const useUserStore = defineStore('user', {
  state: () => {
    return {
      token: '',
      userInfo: {
        id: 0,
        username: "",
        roleId: 0,
        roleInfo: {
          roleId: 0,
          roleIdentifier: "",
          roleDescription: ""
        },
        routePermissions: ""
      }
    };
  },
  actions: {
    /** 只更新账号会话，不自动导航；扫码授权登录后可由页面恢复原确认地址。 */
    setSession(token: string, userInfo: any) { this.token = token; this.userInfo = userInfo; },
    /** 仅清理网页账号会话；电视设备凭证单独保存，不能与账号登录状态混用。 */
    resetSession() { this.token = ''; this.userInfo = { id: 0, username: '', roleId: 0, roleInfo: { roleId: 0, roleIdentifier: '', roleDescription: '' }, routePermissions: '' }; },
    // 设置 token 的方法
    setToken(token: string) {
      this.token = token;
      router.push(isMerchantRole(this.userInfo.roleInfo?.roleIdentifier) ? '/merchant' : '/home/match-list');
    },
    setMobileToken(token: string) {
      this.token = token;
      router.push(isMerchantRole(this.userInfo.roleInfo?.roleIdentifier) ? '/merchant' : '/mhome/head-page');
    },
    // 清除 token 的方法
    clearToken() {
      const merchant = isMerchantPath(router.currentRoute.value.path) || isMerchantRole(this.userInfo.roleInfo?.roleIdentifier);
      this.resetSession();
      const targetLoginPath = merchant ? MERCHANT_LOGIN : isMobileDevice() ? '/mlogin' : '/home/login';
      router.push(targetLoginPath);
    },
    // 设置用户信息的方法
    setUserInfo(userInfo: any) {
      this.userInfo = userInfo;
    },
  },
  persist: [
    {
      key: 'user',
      storage: localStorage,
    }
  ]
});
